import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from 'vue';
import { v4 } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'CCustomCheckbox',
  props: {
    value: { type: Boolean },
    id: null,
    label: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    id?: string;
    label?: string;
    disabled?: boolean;
};





const elementId = ref('');
const vmodel = ref(props.value);

onBeforeMount(() => {
    elementId.value = props.id || `checkbox-${v4()}`;
});

const checked = computed({
    get(): boolean {
        return vmodel.value;
    },
    set(value: boolean) {
        vmodel.value = value;
        emit('input', vmodel.value);
    }
});

return { __sfc: true,emit, props, elementId, vmodel, checked }
}

})